var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.808 17.223v5.554a.826.826 0 01-1.652 0v-.244a1.502 1.502 0 01-.225.02h-2.567a1.501 1.501 0 01-1.501-1.502v-.345h-.644c-.292 0-.41-.157-.456-.39H5v-.896h2.782c.056-.192.178-.315.437-.315h.644v-.156a1.5 1.5 0 011.501-1.5h2.567c.077 0 .152.007.226.018v-.244a.826.826 0 011.65 0zM18 18.459a.586.586 0 00-.585-.586h-2.352v1.171h2.351A.585.585 0 0018 18.46zm-.585 2.457h-2.352v1.17h2.351a.586.586 0 000-1.17z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.192 22.777v-5.554a.826.826 0 011.651 0v.244c.074-.011.149-.019.226-.019h2.567c.829 0 1.501.672 1.501 1.501v.345h.644c.292 0 .41.157.456.39H35v.896h-2.782c-.056.192-.178.316-.437.316h-.644v.155a1.5 1.5 0 01-1.501 1.5h-2.567c-.077 0-.152-.007-.226-.018v.244a.826.826 0 01-1.65 0zM22 21.541c0 .324.262.586.585.586h2.352v-1.171h-2.352a.585.585 0 00-.585.585zm.585-2.457h2.352v-1.17h-2.352a.586.586 0 000 1.17z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 16)",
    d: "M0 0h13v8H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(180 17.5 12)",
    d: "M0 0h13v8H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPower);
export default __webpack_public_path__ + "static/media/ic_power.2a49470e2e1d567b1e2cdc1ff9ce1da6.svg";
export { ForwardRef as ReactComponent };